import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";
import { DEFAULT_ITEMS_PER_PAGE } from "../constants/common";

export default class SupplierService {
  static createSupplier(params) {
    return HttpUtil.post(API_ROUTES.SUPPLIER.SUPPLIERCREATEAPI, params);
  }
  static getSupplierTypes(companyId) {
    return HttpUtil.get(
      API_ROUTES.SUPPLIER.SUPPLIERTYPESAPI.replace("<companyId>", companyId),
      {}
    );
  }
  static checkCompanyEmailExist(emailId) {
    return HttpUtil.get(
      API_ROUTES.SUPPLIER.COMPANYEMAILEXISTCHECKAPI.replace(
        "<emailId>",
        emailId
      ),
      {}
    );
  }
  static listSupplier(
    pageNumber = 0,
    pageSize = DEFAULT_ITEMS_PER_PAGE,
    key = "",
    sort = "",
    companyId,
    invitation_status = "",
    email = "",
    extraParams
  ) {
    let additionalQueryParams = "&";
    if (extraParams && 0 !== Object.keys(extraParams).length) {
      Object.entries(extraParams).forEach(([k, v]) => {
        additionalQueryParams += k + "=" + v + "&";
      });
    }
    // static listSupplier(pageNumber = 0, pageSize = DEFAULT_ITEMS_PER_PAGE, key='', sort='', companyId) {
    return HttpUtil.get(
      API_ROUTES.SUPPLIER.SUPPLIERLISTAPI.replace("<pageNumber>", pageNumber)
        .replace("<pageSize>", pageSize)
        .replace("<key>", key)
        .replace("<sort>", sort)
        .replace("<companyId>", companyId)
        .replace("<invitation_status>", invitation_status)
        .replace("<email>", email)
    );
  }
  static companyConnections(
    companyId,
    pageNumber = 0,
    pageSize = "",
    key = "",
    sort = ""
  ) {
    return HttpUtil.get(
      API_ROUTES.SUPPLIER.COMPANYCONNECTIONSAPI.replace(
        "<pageNumber>",
        pageNumber
      )
        .replace(pageSize ? "<pageSize>" : "&pageSize=<pageSize", pageSize)
        .replace(key ? "<key>" : "&key=<key>", key)
        .replace(sort ? "<sort>" : "&sort=<sort>", sort)
        .replace("<companyId>", companyId)
    );
  }
  static listAllSuppliers(companyId) {
    return HttpUtil.get(
      API_ROUTES.SUPPLIER.ALLSUPPLIERSLISTAPI.replace("<companyId>", companyId)
    );
  }
}
